var scope_0 = require('/tmp/6e5ba538/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/026fdae28bd380b66aeb455726d46f11.js').default;
var scope_1 = require('/tmp/6e5ba538/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_2 = require('/tmp/6e5ba538/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/43991626f0a6373b17db3bf61d208c4f.js').default;
var scope_3 = require('/tmp/6e5ba538/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/46436bfc98456e93f6e4232e4fb0290d.js').default;
var scope_4 = require('/tmp/6e5ba538/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5021bfa321707be62faa6487b11962d5.js').default;
var scope_5 = require('/tmp/6e5ba538/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/51a77ed61e6c55d15a7711d0b54b6101.js').default;
var scope_6 = require('/tmp/6e5ba538/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/63e34c1ecaca5821d64d9c58c7f51cd4.js').default;
var scope_7 = require('/tmp/6e5ba538/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/81a9c3554871b9bdaf6ca6139c3fad07.js').default;
var scope_8 = require('/tmp/6e5ba538/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/850cad33cf0faee25b2f1a17b84febd2.js').default;
var scope_9 = require('/tmp/6e5ba538/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9ffe3980fa8e7e27d80698591269ab0b.js').default;
var scope_10 = require('/tmp/6e5ba538/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d6d00ff37e85b3a73cd17bad3c2834b4.js').default;
var scope_11 = require('/tmp/6e5ba538/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fccc18a827191e35cb5267c1c9b6f97e.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11 )
    